/**
 * CSS Vh Update
 * This scripts assign actual device screen height / 100 to css variable called --vh.
 */

import { debounce } from 'lodash';

custom.cssVhUpdate = (() => {

  /**
   * updateVh
   * Get innerHeight, divide by 100 and assign to --vh
   */
  const updateVh = (event = null, property = "--vh") => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty(property, `${vh}px`);
  }

  /**
   * Init
   * Run the update handler when loaded and resized
   */
  const init = () => {
    updateVh(null, "--vh");
    updateVh(null, "--vhi");
    window.addEventListener('resize', debounce(updateVh, 500));
  }

  return {
    init
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/css-vh-update.js